import { animate, motion } from "framer-motion";
import { ReactNode, useEffect, useState } from "react";

interface GlowingButtonProps {
  from: string;
  to: string;
  children: ReactNode;
  glowing?: boolean;
}

const GlowingButton: React.FC<GlowingButtonProps> = ({
  from,
  to,
  children,
  glowing = true,
}) => {
  // State definition
  const [angle, setAngle] = useState(0);

  useEffect(() => {
    const controls = animate(0, 360, {
      repeat: Infinity,
      repeatType: "loop",
      duration: 3,
      ease: "linear",
      onUpdate: (latest) => setAngle(latest),
    });

    return () => controls.stop();
  }, []);

  return (
    <motion.div
      whileHover={{ scale: 1.06 }}
      className="h-[29px] px-[1px] rounded-full justify-center items-center gap-2 inline-flex relative"
    >
      {glowing && (
        <>
          {/* Sharp border animation */}
          <div
            className="absolute inset-0 rounded-full p-1 z-[1]"
            style={{
              backgroundImage: `conic-gradient(from ${angle}deg, ${from} 0%, ${from} 35%, ${to} 50%, ${to} 85%, ${from})`,
            }}
          />
          {/* Glowing shadow animation */}
          <div
            className="absolute inset-0 rounded-full p-1 z-0 blur-[6px]"
            style={{
              backgroundImage: `conic-gradient(from ${angle}deg, ${from} 0%, ${from} 35%, ${to} 50%, ${to} 85%, ${from})`,
            }}
          />
        </>
      )}
      {children}
    </motion.div>
  );
};

export default GlowingButton;
